import {loggedInEmployeeAtom} from 'atoms/employee';
import {useSkeletonFadeIn} from 'components/DSYS/SkeletonFadeIn';
import {MyWork} from 'components/profile/MyWork';
import {ROUTE_PATHS} from 'constant';
import {useAtomValue} from 'jotai';
import {DashboardState} from 'views/home/dashboard/dashboardModel';
import {Tile} from 'views/home/dashboard/Tile';
import {TileHeaderLink} from 'views/home/dashboard/TileListFooter';
import {TileListSkeleton} from 'views/home/dashboard/tiles/TileListSkeleton';
import {viaState} from 'views/workstreams/page/workstreamsAnalytics';

export const WorkstreamsTile = ({state}: {state: DashboardState}) => {
  const {employee} = useAtomValue(loggedInEmployeeAtom);
  // The viewer's profile resolves into a jotai atom rather than a query, so we
  // treat "profile not resolved yet" as loading to avoid flashing the empty
  // state before MyWork can load the workstream tracker.
  const isLoading = state.workstreamsLoading || !employee?.user_id;
  const bodyRef = useSkeletonFadeIn(isLoading);

  return (
    <Tile
      tileId="workstreams"
      bodyRef={bodyRef}
      accessory={<TileHeaderLink to={ROUTE_PATHS.WORKSTREAMS} state={viaState('home_tile')} />}
    >
      {isLoading ? (
        <TileListSkeleton bare accessory="none" trailing="chip" rows={4} />
      ) : (
        <MyWork employee={employee} source="dashboard" embedded />
      )}
    </Tile>
  );
};
